import React from 'react'

import { DeviceType, useDeviceType } from '@library/dom'

import { CUSTOMER_REVIEWS } from '../../../config'
import { Carousel, type CarouselProps } from '../../EndlessVarietySection/Carousel'
import { ReviewsCard } from './ReviewsCard'
import { Box } from '@gousto-internal/citrus-react'
import { LandingPageContentSections } from '../../../tracking'

const propertiesForTracking = {
  carouselSection: LandingPageContentSections.CUSTOMER_REVIEWS,
}

export const ReviewsCarousel = () => {
  const deviceType = useDeviceType()
  const isMobileDevice = deviceType === DeviceType.MOBILE
  const isDesktopDevice = deviceType === DeviceType.DESKTOP
  const carouselWrapperStyle = deviceType === DeviceType.TABLET ? { paddingLeft: '8px' } : undefined
  let carouselOptions: CarouselProps['options']

  if (isDesktopDevice) {
    carouselOptions = {
      align: 'center' as const,
      containScroll: 'trimSnaps',
      loop: false,
    }
  } else if (isMobileDevice) {
    carouselOptions = { align: 'start' as const, loop: false }
  } else {
    carouselOptions = { align: 'center' as const, loop: true }
  }

  return (
    <Box data-testid="reviews-carousel" style={carouselWrapperStyle}>
      <Carousel
        carouselAreaLabel="reviewsCarousel"
        options={carouselOptions}
        slidePaddingH={2}
        slidePaddingV={1}
        showNavButtons={!isMobileDevice}
        autoHideNavButtons
        startAtMiddleAvailableSnap={isDesktopDevice}
        centerSlidesWhenNotScrollable={isDesktopDevice}
        snowplowTrackingProperties={propertiesForTracking}
      >
        {CUSTOMER_REVIEWS.review.map(({ quote, reviewer }, index) => (
          <Box key={`${reviewer}-${index}`}>
            <ReviewsCard quote={quote} reviewer={reviewer} />
          </Box>
        ))}
      </Carousel>
    </Box>
  )
}
